import { useCallback, useState } from 'react';
import { DEFAULT_RECENT, shapeByName } from './shapeLibrary';

// Per-browser sidebar preferences. Storage can be missing or blocked, so every access falls back quietly.
const RECENT_KEY = 'mindmap.sidebar.recent';
const COLLAPSED_KEY = 'mindmap.sidebar.collapsed';
const RECENT_COUNT = 4;

const read = (key, fallback) => {
    try {
        const raw = localStorage.getItem(key);
        return raw === null ? fallback : JSON.parse(raw);
    } catch (error) {
        return fallback;
    }
};

const write = (key, value) => {
    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        // Storage unavailable: the preference lasts for this page only.
    }
};

const knownNames = (names) => (Array.isArray(names) ? names.filter((name) => shapeByName(name)) : DEFAULT_RECENT);

// The last four shapes dragged from the sidebar, most recent first.
export const useRecentShapes = () => {
    const [names, setNames] = useState(() => knownNames(read(RECENT_KEY, DEFAULT_RECENT)));
    const remember = useCallback((name) => {
        setNames((current) => {
            const next = [name, ...current.filter((other) => other !== name)].slice(0, RECENT_COUNT);
            write(RECENT_KEY, next);
            return next;
        });
    }, []);
    return [names.map(shapeByName), remember];
};

export const useCollapsed = () => {
    const [collapsed, setCollapsedState] = useState(() => read(COLLAPSED_KEY, false) === true);
    const setCollapsed = useCallback((value) => {
        write(COLLAPSED_KEY, value);
        setCollapsedState(value);
    }, []);
    return [collapsed, setCollapsed];
};
